import { motion } from 'framer-motion'

export default function PaymentInfo() {
  return (
    <motion.div
        className="w-full h-92.5"
        exit={{
            x: "-200px",
            opacity: 0
        }}
        initial={{
            opacity: 0,
            x: "100px"
        }}
        animate={{
            opacity: 1,
            x: 0
        }}
    >
        <div
            className="absolute top-1/2 left-1/2 translate-x-neg-1/2 translate-y-neg-1/2 bg-white py-8 px-12 shadow-2xl rounded"
        >
            <header className='leading-7 text-center'>
                <h2 className='font-semibold text-2xl'>Payment Info</h2>
                <span className="text-graphite" >Please select your preferred plan</span>
            </header>

            <div
                className="my-12 w-full"
            >
                
            </div>
            
        </div>
    </motion.div>
  )
}
